import * as tslib_1 from "tslib";
import { put, takeLatest, call, all, takeEvery, select, } from 'redux-saga/effects';
import { actions as userActions } from '../redux/users';
import { request } from '../xhr';
import ddt from '@wix/da-ddt';
import { requestSuccess, requestFailure, reportComment, likeComment, featureComment, unfeatureComment, unlikeComment, hideComment, unhideComment, } from './actionCreators';
import { RequestError } from './types';
import { getCommentsByUser } from './selectors';
import { getIsLoggedIn } from '../publicSession/selectors';
import { restrictLoggedOut } from '../redux/loggedout';
import { addNotification, removeNotification, } from '../Notifications/redux/actionCreators';
import { NotificationType } from '../Notifications';
import { ReferralType } from '../biLogger';
function fakeResponse(options) {
    ddt.log('comments', 'faking the response!');
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        // eslint-disable-next-line
        var comments = require('@wix/da-sample-data').comments;
        return {
            success: true,
            comment: comments[0],
        };
    }
}
function getError(result) {
    return result.error_description;
}
function doActionRequest(action, type, comment, data) {
    var isLoggedIn, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.COMMENT_ACTION }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                ddt.log('comments', "calling " + action + " comment saga");
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/comments" + action,
                        data: data || {
                            itemid: comment.itemId,
                            commentid: comment.commentId,
                        },
                    }, fakeResponse)];
            case 4:
                result = _a.sent();
                if (!(result && result.success)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(requestSuccess(type, comment))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(requestFailure(type, comment, getError(result)))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function featureCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, call(doActionRequest, '/feature', type, comment)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function unfeatureCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, call(doActionRequest, '/unfeature', type, comment)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function likeCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, call(doActionRequest, '/like', type, comment)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function unlikeCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, call(doActionRequest, '/unlike', type, comment)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function reportCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, call(doActionRequest, '/report', type, comment)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function hideCommentSaga(action) {
    var type, _a, comment, insideModal;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, _a = action.payload, comment = _a.comment, insideModal = _a.insideModal;
                return [4 /*yield*/, call(doActionRequest, '/hide', type, comment)];
            case 1:
                _b.sent();
                return [4 /*yield*/, put(addNotification(NotificationType.DeleteComment, {
                        id: comment.commentId,
                        comment: comment,
                        insideModal: insideModal,
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function unhideCommentSaga(action) {
    var type, comment;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, comment = action.payload.comment;
                return [4 /*yield*/, put(removeNotification(comment.commentId))];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(doActionRequest, '/unhide', type, comment)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function blockUserSuccessSaga(action) {
    var type, blockedUserId, commentsByUser;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, blockedUserId = action.payload;
                return [4 /*yield*/, select(getCommentsByUser, blockedUserId)];
            case 1:
                commentsByUser = _a.sent();
                return [4 /*yield*/, all(commentsByUser.map(function (comment) { return put(requestSuccess(type, comment)); }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function blockUserFailSaga(action) {
    var type, blockedUserId, error, commentsByUser;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                type = action.type, blockedUserId = action.payload;
                error = getError(action.meta) || RequestError.GeneralError;
                return [4 /*yield*/, select(getCommentsByUser, blockedUserId)];
            case 1:
                commentsByUser = _a.sent();
                return [4 /*yield*/, all(commentsByUser.map(function (comment) { return put(requestFailure(type, comment, error)); }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(featureComment, featureCommentSaga),
                    takeLatest(unfeatureComment, unfeatureCommentSaga),
                    takeLatest(likeComment, likeCommentSaga),
                    takeLatest(unlikeComment, unlikeCommentSaga),
                    takeLatest(hideComment, hideCommentSaga),
                    takeLatest(unhideComment, unhideCommentSaga),
                    takeLatest(reportComment, reportCommentSaga),
                    takeEvery(userActions.blockUserSuccess, blockUserSuccessSaga),
                    takeEvery(userActions.blockUserFail, blockUserFailSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map